import { getTemplatePage } from "../../../data/models/page.model";
import { bus } from "@/main";


export default {
	name: "ContactsPage",
	data() {
		return {
			content: null,
			isReady: false,
		}
	},
	props: {},
	created() {
		this.getContent();
	},
	watch: {},
	computed: {},
	methods: {
		getContent() {
			let contentReady = new Promise((resolve, reject) => {
				getTemplatePage('pages/contact-page.php').then(
					content => {
						this.content = content,
						this.isReady = true
					}
				)
			})
			Promise.all([contentReady]).then(() => {
				bus.$emit("pageIsReady", true);
			})
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/contacts/contacts.page.js